import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import i18n from './locales'

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
  key: 'store',
  storage: window.localStorage
})

export default new Vuex.Store({
  state: {
    language: navigator.language ? navigator.language : 'fr'
  },

  getters: {
    language: state => state.language
  },

  mutations: {
    changeLang: (state, language) => {
      state.language = language
      i18n.locale = language
    }
  },

  actions: {
    changeLang ({ commit }) {
      commit('changeLang')
    }
  },

  plugins: [vuexLocalStorage.plugin]
})
